import { render, staticRenderFns } from "./NavbarHorizontal.vue?vue&type=template&id=0b851d5c&"
import script from "./NavbarHorizontal.vue?vue&type=script&lang=js&"
export * from "./NavbarHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports